import { render } from "./collection-product.vue?vue&type=template&id=2c1682c8"
import script from "./collection-product.vue?vue&type=script&lang=js"
export * from "./collection-product.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__